import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			noDataOptions: {
				hide: false,
			},
			cardProps: {
				queries: {
					title: {
						queryOptionsType: 'none',
						value: '{sub:fund} - {sub:clss}',
						subQueries: [
							{
								queryId: 'fund',
								queryOptionsType: 'property',
								entityType: 'CLSS',
								code: 'fund_name',
							},
							{
								queryId: 'clss',
								queryOptionsType: 'property',
								entityType: 'CLSS',
								code: 'isin',
							},
						],
					},
				},
			},
			commentary: {
				queryOptionsType: 'none',
				value: 'Commentary Text Goes HERE...',
			},
		},
		actions: {
			props: {
				buttons: [
					{
						redirect: {
							defaultUrl: '/{site}/{country}/{language}/{investorType}/contact/',
							options: {
								preserveOriginHash: false,
								preserveOriginPath: false,
								preserveOriginQueryString: false,
							},
						},
						text: 'CONTACT US',
					},
				],
			},
		},
	},
	redirectInputs: [
		{
			key: 'site',
			query: {
				key: 'site',
				queryOptionsType: 'input',
				transforms: [
					{
						caseType: 'param',
						transformOptionsType: 'case',
					},
				],
			},
		},
		{
			key: 'country',
			query: {
				key: 'country',
				queryOptionsType: 'input',
				transforms: [
					{
						caseType: 'param',
						transformOptionsType: 'case',
					},
				],
			},
		},
		{
			key: 'language',
			query: {
				key: 'language',
				queryOptionsType: 'input',
				transforms: [
					{
						caseType: 'param',
						transformOptionsType: 'case',
					},
				],
			},
		},
		{
			key: 'investorType',
			query: {
				key: 'investorType',
				queryOptionsType: 'input',
				transforms: [
					{
						caseType: 'param',
						transformOptionsType: 'case',
					},
				],
			},
		},
	],
};
